var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewtab = function SvgNewtab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.646 9.303 20 8.95V4h-4.95l-.353.354 1.767 1.767L11 11.586 12.414 13l5.465-5.464 1.767 1.767Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18v-5.465l2-2V20H4V7h9.465l-2 2H6v9h9Z",
    fill: "#4D4D4D"
  })));
};
export { SvgNewtab as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTkuNjQ2IDkuMzAzTDIwIDguOTVWNEgxNS4wNUwxNC42OTcgNC4zNTRMMTYuNDY0IDYuMTIxTDExIDExLjU4NkwxMi40MTQgMTNMMTcuODc5IDcuNTM2TDE5LjY0NiA5LjMwM1oiIGZpbGw9IiM0RDRENEQiLz4KPHBhdGggZD0iTTE1IDE4VjEyLjUzNUwxNyAxMC41MzVWMjBINFY3SDEzLjQ2NUwxMS40NjUgOUg2VjE4SDE1WiIgZmlsbD0iIzRENEQ0RCIvPgo8L3N2Zz4K";